<template>
  <b-form>
    <b-form-group
      :label="`${$t('auction.select_sections')}:`"
      label-cols="5"
    >
      <a-tree
        v-model="sections"
        :tree-data="categories"
        checkable
        show-line
        @check="handleCheck"
      />
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  name: 'SelectSections',
  model: {
    prop: 'auctionCategories',
    event: 'change',
  },
  props: {
    auctionCategories: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sections: [],
    }
  },

  watch: {
    auctionCategories: {
      handler(newVal) {
        this.sections = newVal.map(id => `section_${id}`)
      },
      immediate: true,
      deep: true,

    },
  },

  methods: {

    handleChange() {
      this.$emit('change')
    },

    handleCheck() {
      const res = []
      this.sections.forEach(node => {
        const [type, id] = node.split('_')
        if (type === 'section') {
          res.push(Number(id))
        }
      })

      this.$emit('change', res)
    },
  },
}
</script>
